export function createStatementOfPositionMapConfig() {
	return {
		title: "Statement of Position Map",
		instructions: "Use your own words. You can leave any part open and return to it later.",
		visibility: "shared",
		guidance: "detailed",
		tentativeLabel: "This wording is tentative",
		fixedPromptSequence: true,
		trackCompletion: true,
		showPriorResults: true,
		sections: [
			{id: "problem", title: "Name the problem", description: "Name or describe the problem in terms that fit your experience."},
			{id: "evaluation", title: "Effects and evaluation", description: "Describe the effects before saying how you feel about them."},
			{id: "values", title: "Values and reasons", description: "Explore what matters behind your position."},
			{id: "direction", title: "Preferred direction", description: "Say what you would prefer in your relationship with the problem."},
		],
		fields: [
			{id: "problemName", sectionId: "problem", type: "MULTILINE", title: "What would you call this problem that you’re struggling with?", isCompletionRequired: true},
			{id: "problemEffects", sectionId: "evaluation", type: "MULTILINE", title: "In which areas of your life is it most present? What effects have you noticed?", isCompletionRequired: true},
			{id: "effectsEvaluation", sectionId: "evaluation", type: "MULTILINE", title: "How do you evaluate these effects? Would you call them positive or negative or something in-between?", isCompletionRequired: true},
			{id: "positionReasons", sectionId: "values", type: "MULTILINE", title: "Why is it you take the position you do? What is important to you?", isCompletionRequired: true},
			{id: "preferredDirection", sectionId: "direction", type: "MULTILINE", title: "What would you prefer?", isCompletionRequired: true},
		],
	}
}

